import { Component, OnInit } from '@angular/core';
import { IPeriodicite } from 'src/app/models/periodicite.model';
import { PeriodiciteService } from 'src/app/services/periodicite.service';

@Component({
  selector: 'app-courses-grid-style-one-columns-three-page',
  templateUrl: './courses-grid-style-one-columns-three-page.component.html',
  styleUrls: ['./courses-grid-style-one-columns-three-page.component.scss']
})
export class CoursesGridStyleOneColumnsThreePageComponent implements OnInit {
  offres: IPeriodicite[] = [];
  loading = false;

  constructor(
    private periodicite: PeriodiciteService
  ) { }

  ngOnInit(): void {
    this.gets();
  }

  gets(): void {
    this.loading = true;
    this.periodicite.gets().subscribe(resp => {
      this.offres = resp.objects;
      this.loading = false;
      console.log(this.offres);
    });
  }

}
